import { Button } from '@design-system/components/button/button';
import { Controller } from 'react-hook-form';
import { Typography } from '@design-system/components/typography/typography';
import { Switch, Breadcrumbs } from '@mui/material';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import { Schedule } from './Schedule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

export const Header = ({
  dispatch,
  control,
  currentBreadcrumb,
  watch,
  isNewForm,
  publishAction,
  readonly,
  errorMessage,
  newWorkoutErrors,
}: Pick<
  EditWorkoutVM,
  | 'dispatch'
  | 'control'
  | 'currentBreadcrumb'
  | 'watch'
  | 'isNewForm'
  | 'publishAction'
  | 'readonly'
  | 'errorMessage'
  | 'newWorkoutErrors'
>) => (
  <div>
    <div className="w-full p-5">
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          className="cursor-pointer"
          onClick={() => dispatch('navigateToWorkouts')}
        >
          Workouts
        </Typography>
        <Typography color="B-100">{currentBreadcrumb}</Typography>
      </Breadcrumbs>
    </div>
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-4">
      {errorMessage || Object.keys(newWorkoutErrors).length > 0 ? (
        <div className="flex w-full gap-2 bg-[#FFE2E2] pl-4 py-3.5 pr-2 rounded-[10px]">
          <FontAwesomeIcon
            icon={faExclamationCircle}
            className="text-[#DA0000]"
          />
          <div className="flex flex-col gap-2">
            {errorMessage ? (
              <Typography className="flex w-full">{errorMessage}</Typography>
            ) : (
              <Typography className="flex w-full">
                Required fields are missing or invalid. Check the marked fields
                and try again.
              </Typography>
            )}

            <ul className="flex flex-col gap-2">
              {Object.entries(newWorkoutErrors).map(([key, error]) => (
                <li key={key}>
                  <Typography className="flex w-full">
                    <a href={`#${key}`} className="text-inherit">
                      {error}
                    </a>
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
      <div className="flex flex-wrap items-center md:self-end gap-4 ml-auto">
        <div className="pl-4 md:pl-0 flex items-center">
          <Typography>Free sample</Typography>
          <Controller
            name={'freeSample'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Switch
                checked={value}
                onChange={onChange}
                data-testid="freeSample"
                disabled={readonly}
              />
            )}
          />
        </div>
        <Button
          color="neutral"
          variant="text"
          onClick={() => dispatch('save')}
          disabled={readonly}
        >
          {isNewForm ? 'Save as draft' : 'Save'}
        </Button>
        <Schedule dispatch={dispatch} watch={watch} disabled={readonly} />
        <Button
          color="neutral"
          onClick={publishAction.onClick}
          disabled={readonly || publishAction.disabled}
        >
          {publishAction.label}
        </Button>
      </div>
    </div>
  </div>
);
